import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

import { PATH } from '../../constants/global'
import { useAPI } from '..'

export default function useNotificationTotals({
   toolId,
}: UseNotificationTotalsOptions): UseNotificationTotals {
   const request = useAPI()
   const {
      data: regularTotals,
      isLoading: isLoadingRegular,
      isRefetching: isRefetchingRegular,
      refetch: refetchRegular,
      isSuccess,
   } = useQuery(['notification-total', { toolId }], () =>
      getTotalsFromAPI(toolId)
   )
   const {
      data: globalTotalData,
      isLoading: isLoadingGlobal,
      isRefetching: isRefetchingGlobal,
      refetch: refetchGlobal,
   } = useQuery(['global-notification-total', { toolId }], () =>
      getGlobalTotalFromAPI(toolId)
   )

   async function getTotalsFromAPI(
      toolId?: number
   ): Promise<AxiosResponse<NotificationTotalsResponse>> {
      return request.get(PATH.DASHBOARD.NOTIFICATION_TOTALS, {
         params: {
            returnCompanyNotifications: false,
            toolId: toolId,
         },
      })
   }

   async function getGlobalTotalFromAPI(toolId?: number): Promise<{
      notificationTotals: NotificationTotalsResponse
      globalTotal: number
   }> {
      try {
         const totalsResponse = await request.get<NotificationTotalsResponse>(
            PATH.DASHBOARD.NOTIFICATION_TOTALS,
            {
               params: {
                  returnCompanyNotifications: true,
                  toolId: toolId,
               },
            }
         )

         const globalTotal = totalsResponse.data.Data.ActionTasks || 0

         return {
            notificationTotals: totalsResponse.data,
            globalTotal: globalTotal,
         }
      } catch (error) {
         console.log(error)
         return {
            notificationTotals: {} as NotificationTotalsResponse,
            globalTotal: 0,
         }
      }
   }

   const {
      ActionTasks = 0,
      ReminderTasks = 0,
      InformationalTasks = 0,
   } = regularTotals?.data?.Data || {}

   const GlobalTasks = globalTotalData?.globalTotal || 0

   const totalNotifications = ActionTasks + ReminderTasks + InformationalTasks

   const refresh = () => {
      refetchRegular()
      refetchGlobal()
   }

   return {
      isLoading:
         isLoadingRegular ||
         isRefetchingRegular ||
         isLoadingGlobal ||
         isRefetchingGlobal,
      isSuccess,
      refresh,
      totals: {
         ActionTasks,
         ReminderTasks,
         InformationalTasks,
         GlobalTasks,
      },
      totalNotifications,
   }
}
